import { Icon, type IconProps } from './Icon';

// Drawn on the Figma 16-unit frame (sleek Vault pill, 2026-10-08) so the
// four squares keep their exact offsets instead of being rescaled to 24.
export function Grid(props: IconProps) {
  return (
    <Icon viewBox="0 0 16 16" strokeWidth={1.75} {...props}>
      <rect x="1.875" y="1.875" width="4.375" height="4.375" rx="0.875" />
      <rect x="9.75" y="1.875" width="4.375" height="4.375" rx="0.875" />
      <rect x="1.875" y="9.75" width="4.375" height="4.375" rx="0.875" />
      <rect x="9.75" y="9.75" width="4.375" height="4.375" rx="0.875" />
    </Icon>
  );
}
